import http from '@/utils/http'
export const getMachineInfo = data => http.get("/rvm-center/api/machine/map", {
    params: data,
    traditional: true,
})
export const getMapInfo = data => http.get(`/map/search?q=${data}&viewbox=113.7662,22.5944,114.5215,22.1162&bounded=1&format=json`, {
    params: data
}) //获取地图信息
export const getlatlng = data => http.get(`/map/reverse?format=json&lat=${data[0]}&lon=${data[1]}&zoom=18&addressdetails=1`, {
    params: data
}) //获取地图信息

export default {
    getMachineInfo,
    getMapInfo,
    getlatlng
}